<template>
  <div>
    <div style="height: 100%">
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="商户名称">
                  <el-input
                    v-model="form.pbmc"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属片区">
                  <el-input
                    v-model="form.pian"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属社区">
                  <el-input
                    v-model="form.sq"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属联盟">
                  <el-input
                    v-model="form.zu"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="负责人">
                  <el-input
                    v-model="form.zrr"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否含用户账户">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.hasAccountFlag"
                  >
                    <el-option
                      v-for="item in sfyyList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 10px; display: flex; justify-content: space-between; align-items: center;">
          <div>
            <el-button class="search btn-outline-blue" size="small" @click="downloadTemplate"
              ><i class="el-icon-download"></i> 模板下载</el-button
            >
            <!-- <el-button class="search" size="small" @click="uploadSh">上传商户</el-button> -->
            <el-upload
              class="upload-demo"
              accept=".xlsx"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="importDataFun"
            >
              <el-button class="search btn-outline-blue" size="small" style="margin: 0 10px;"
                ><i class="el-icon-upload"></i> 上传商户</el-button
              >
            </el-upload>
            <el-button class="search btn-outline-blue" size="small" @click="exportShanghu" :loading="exportLoading"
              ><i class="el-icon-s-promotion"></i> 导出</el-button
            >
          </div>
          <div>
            <el-button class="search btn-outline-blue" size="small" @click="goNoticeManagement"
              ><i class="el-icon-bell"></i> 通知管理</el-button
            >
            <el-button class="search" size="small" @click="addSh"
              ><i class="el-icon-plus"></i> 新增商户</el-button
            >
          </div>
        </div>
        <div class="aside">
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="500"
            v-loading="loading"
          >
            <template v-slot:operation="{ scope }">
              <el-button
                style="font-size: 16px"
                type="text"
                @click="toDetail(scope.row)"
                >详情</el-button
              >
              <el-button
                style="font-size: 16px;margin-right: 10px;"
                type="text"
                @click="toEdit(scope.row)"
                >编辑</el-button
              >
              <el-popconfirm
                title="确定删除吗？"
                trigger="click"
                @confirm="deleteType(scope.row)"
              >
                <el-button style="font-size: 16px" slot="reference" type="text"
                  >删除</el-button
                >
              </el-popconfirm>
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <el-dialog
      title="上传商户"
      :visible.sync="dialogVisible"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="user-form">
        <el-form label-width="100px" label-position="top">
          <el-form-item label="下载模板">
            <el-button size="mini">下载</el-button>
          </el-form-item>
          <el-form-item label="导入商户数据">
            <el-button size="mini">导入</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      :title="formInline.id ? '编辑商户' : '新增商户'"
      :visible.sync="dialogVisible2"
      width="50%"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="container-dialog">
        <div class="left">
          <el-form :model="formInline" ref="form" :rules="rules">
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="商户名称" prop="pbmc">
                  <el-input
                    v-model="formInline.pbmc"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="统一社会信用代码" prop="tyshxydm">
                  <el-input
                    v-model="formInline.tyshxydm"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="是否营业" prop="sfyy">
                  <el-select placeholder="请选择" v-model="formInline.sfyy">
                    <el-option
                      v-for="(item, index) in sfyyList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="负责人" prop="zrr">
                  <el-input
                    v-model="formInline.zrr"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="负责人联系电话" prop="zrrsjh">
                  <el-input
                    v-model="formInline.zrrsjh"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="所属片区" prop="pian">
                  <el-input
                    v-model="formInline.pian"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="所属社区" prop="sq">
                  <el-input v-model="formInline.sq" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="所属联盟" prop="zu">
                  <el-input v-model="formInline.zu" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="社区负责人" prop="">
                  <el-input v-model="formInline.sqfzr" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="社区负责人手机号" prop="">
                  <el-input v-model="formInline.sqfzrsjh" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="执法队负责人" prop="">
                  <el-input v-model="formInline.zfdfzr" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="执法队负责人手机号" prop="">
                  <el-input v-model="formInline.zfdfzrsjh" placeholder="请输入"></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="责任主体名称" prop="zrztmc">
                  <el-input
                    v-model="formInline.zrztmc"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="责任主体地址" prop="zrztdz">
                  <el-input
                    v-model="formInline.zrztdz"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20">
                <el-form-item label="所属道路" prop="dlmc">
                  <el-input
                    v-model="formInline.dlmc"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </div>
              <div class="box-1 mr-20">
                <el-form-item label="中心经度" prop="longitude">
                  <el-input
                    v-model="formInline.longitude"
                    placeholder="请输入"
                  >
                    <template slot="append">°E</template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
            <div class="box box-column-center">
              <div class="box-1 mr-20 box box-column-center">
                <el-form-item label="中心纬度" prop="latitude">
                  <el-input
                    v-model="formInline.latitude"
                    placeholder="请输入"
                  >
                    <template slot="append">°N</template>
                  </el-input>
                </el-form-item>
                <el-button
                  @click="mapVisible = true"
                  type="text"
                  style="margin-left: 10px;"
                  >地图定位</el-button
                >
              </div>
              <div class="box-1 box box-column">
                <!-- extendTimeRange -->
                <el-form-item label="打卡时段" prop="">
                </el-form-item>
                <div class="box box-column-center" style="margin-top: -20px;">
                  <el-time-select
                    v-model="time1"
                    :picker-options="{
                      start: '00:30',
                      step: '00:15',
                      end: '23:45'
                    }"
                    style="width: 200px;"
                    placeholder="选择开始时段">
                  </el-time-select>
                  <el-time-select
                    v-model="time2"
                    :picker-options="{
                      start: '00:30',
                      step: '00:15',
                      end: '23:45',
                      minTime: time1
                    }"
                    style="width: 200px;margin-left: 10px;"
                    placeholder="选择结束时段">
                  </el-time-select>
                </div>
              </div>
            </div>
            <div class="box box-column">
              <el-form-item label="标准图片" class="box-1 box">
              </el-form-item>
              <div class="box-1 box mt-10" style="margin-top: -20px;">
                <div class="mr-20">左侧图片</div>
                <div class="box box-wrap">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="(file) => handleRemove(file, 1)"
                    :file-list="ckImgLeftJson"
                    list-type="picture"
                    accept="image/png,image/jpg,image/jpeg"
                    :http-request="(file) => uploadPicFileFun(file, 1)"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-preview="handlePreview"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
              </div>
              <div class="box-1 box mt-10">
                <div class="mr-20">中间图片</div>
                <div class="box box-wrap">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="(file) => handleRemove(file, 2)"
                    :file-list="ckImgCentreJson"
                    list-type="picture"
                    accept="image/png,image/jpg,image/jpeg"
                    :http-request="(file) => uploadPicFileFun(file, 2)"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-preview="handlePreview"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
              </div>
              <div class="box-1 box mt-10">
                <div class="mr-20">右侧图片</div>
                <div class="box box-wrap">
                  <el-upload
                    class="upload-demo"
                    drag
                    action="#"
                    :on-remove="(file) => handleRemove(file, 3)"
                    :file-list="ckImgRightJson"
                    list-type="picture"
                    accept="image/png,image/jpg,image/jpeg"
                    :http-request="(file) => uploadPicFileFun(file, 3)"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-preview="handlePreview"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="addOrUpdateFun">保 存</el-button>
      </span>
    </el-dialog>
    <mapSearch
      @cancel="mapVisible = false"
      @map-confirm="confirmLocation"
      :visible="mapVisible"
    ></mapSearch>

    <!-- 图片预览弹窗（隐藏，点击预览时显示） -->
    <el-dialog
      :visible.sync="previewVisible"
      title="图片预览"
      append-to-body
    >
      <el-image
        :src="previewImageUrl"
        fit="contain"
        style="width: 100%;height: 50vh;"
      ></el-image>
    </el-dialog>

  </div>
</template>
<script>
import {
  shanghuInfoPage,
  shanghuInfoDel,
  shanghuInfoEdit,
  shanghuInfoDetail,
  shanghuInfoImport,
  shanghuExp
} from "@/api/shanghu";
import commonTable from "@/components/table/index.vue";
import { downloadFile } from "@/api/systemManagement.js";
import shtzDetail from "./shtzDetail.vue";
import mapSearch from "@/components/map-search/index.vue";
import { uploadFile } from "@/api/block.js";
export default {
  components: {
    shtzDetail,
    commonTable,
    mapSearch
  },
  data() {
    return {
      previewVisible: false,
      previewImageUrl: '',
      time1: '',
      time2: '',
      mapVisible: false,
      exportLoading: false,
      dialogVisible: false,
      dialogVisible2: false,
      showDetail: false,
      // 新增对象/详情
      formInline: {},
      sfyyList: [
        {
          label: "是",
          value: "是"
        },
        {
          label: "否",
          value: "否"
        }
      ],
      rules: {
        dlmc: [
          {
            required: true,
            message: "请输入所属道路",
            trigger: ["blur", "change"]
          }
        ],
        pbmc: [
          {
            required: true,
            message: "请输入商户名称",
            trigger: ["blur", "change"]
          }
        ],
        sfyy: [
          {
            required: true,
            message: "请选择是否营业",
            trigger: ["blur", "change"]
          }
        ],
        // tyshxydm: [
        //   {
        //     required: true,
        //     message: "请输入统一社会信用代码",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        zrr: [
          {
            required: true,
            message: "请输入负责人",
            trigger: ["blur", "change"]
          }
        ],
        zrrsjh: [
          {
            required: true,
            message: "请输入负责人联系电话",
            trigger: ["blur", "change"]
          }
        ],
        zrztdz: [
          {
            required: true,
            message: "请输入主体地址",
            trigger: ["blur", "change"]
          }
        ],
        zrztmc: [
          {
            required: true,
            message: "请输入主体名称",
            trigger: ["blur", "change"]
          }
        ],
        zu: [
          {
            required: true,
            message: "请输入所属联盟",
            trigger: ["blur", "change"]
          }
        ],
        sq: [
          {
            required: true,
            message: "请输入所属社区",
            trigger: ["blur", "change"]
          }
        ],
        extendTimeRange: [
          {
            required: true,
            message: "请选择时间段",
            trigger: ["blur", "change"]
          }
        ],
      },
      ckImgLeftJson: [],
      ckImgCentreJson: [],
      ckImgRightJson: [],
      // 搜索对象
      form: {
        dlmc: "",
        id: "",
        latitude: "",
        longitude: "",
        pbmc: "",
        pian: "",
        sfyy: "",
        sq: "",
        tyshxydm: "",
        zrr: "",
        zrrsjh: "",
        zrztdz: "",
        zrztmc: "",
        zu: ""
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pbmc",
            label: "商户名称"
          },
          {
            prop: "tyshxydm",
            label: "统一社会信用代码",
            width: '200px'
          },
          {
            prop: "sfyy",
            label: "是否营业"
          },
          {
            prop: "zrr",
            label: "负责人"
          },
          {
            prop: "zrrsjh",
            label: "负责人联系电话"
          },
          {
            prop: "zrztdz",
            label: "所属道路"
          },
          {
            prop: "pian",
            label: "所属片区"
          },
          {
            prop: "zu",
            label: "所属联盟"
          },
          {
            prop: "sq",
            label: "所属社区"
          },
          {
            prop: "relHasAccountCount",
            label: "用户数"
          },
          {
            slot: "operation",
            label: "操作",
            width: '200px'
          }
        ]
      },
      loading: false,
    };
  },
  mounted() {
    if (sessionStorage.getItem('shtzSearch')) {
      this.form = JSON.parse(sessionStorage.getItem('shtzSearch'));
      this.page = {
        size: JSON.parse(sessionStorage.getItem('shtzSearch')).size,
        page: JSON.parse(sessionStorage.getItem('shtzSearch')).page,
        total: JSON.parse(sessionStorage.getItem('shtzSearch')).total
      }
    }
    this.getPointTypeListPageFun();
  },
  methods: {
    handleExceed() {
      // 自定义提示文案，替换默认的静默拦截
      this.$message.warning(`最多只能上传一张图片，请删除后再添加！`);
    },
    handlePreview(file) {
      console.log(file)
      // 触发预览弹窗，赋值图片地址
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    handleRemove(file, olbtype) {
      if (olbtype == 1) this.ckImgLeftJson.splice(this.ckImgLeftJson.findIndex(item => item.id == file.id), 1);
      if (olbtype == 2) this.ckImgCentreJson.splice(this.ckImgCentreJson.findIndex(item => item.id == file.id), 1);
      if (olbtype == 3) this.ckImgRightJson.splice(this.ckImgRightJson.findIndex(item => item.id == file.id), 1);
    },
    uploadPicFileFun(file, olbtype) {
      if (!file.file.name.endsWith(".jpeg") && !file.file.name.endsWith(".jpg") && !file.file.name.endsWith(".png")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.jpeg、.jpg、.png",
          type: "warning"
        });
        return;
      }
      this.uploadFileFun(file, "gh_block_organization", olbtype);
    },
    async uploadFileFun(file, type, olbtype) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("objectName", type);
      const res = await uploadFile(formData);
      if (res.data.code === 200) {
        if (olbtype == 1) {
          this.ckImgLeftJson.push({
            ...res.data.data,
            name: res.data.data.fileName,
            url:
              process.env.VUE_APP_API_IMG_PATH + res.data.data.filePath,
            imageUrl: res.data.data.filePath,
            view: '左'
          });
        }
        if (olbtype == 2) {
          this.ckImgCentreJson.push({
            ...res.data.data,
            name: res.data.data.fileName,
            url:
              process.env.VUE_APP_API_IMG_PATH + res.data.data.filePath,
            imageUrl: res.data.data.filePath,
            view: '中'
          });
        }
        if (olbtype == 3) {
          this.ckImgRightJson.push({
            ...res.data.data,
            name: res.data.data.fileName,
            url:
              process.env.VUE_APP_API_IMG_PATH + res.data.data.filePath,
            imageUrl: res.data.data.filePath,
            view: '右'
          });
        }
      }
    },

    confirmLocation(e) {
      this.formInline.longitude = e.lng;
      this.formInline.latitude = e.lat;
      this.formInline.dlmc = e.addr;
      this.mapVisible = false;
    },
    // 新增商户
    addSh() {
      this.formInline = this.$options.data().formInline;
      this.time1 = '';
      this.time2 = '';
      this.dialogVisible2 = true;
      this.ckImgLeftJson = [];
      this.ckImgCentreJson = [];
      this.ckImgRightJson = [];
    },
    // 通知管理
    goNoticeManagement() {
      this.$emit('goToNoticeManagement');
    },
    // 上传商户
    uploadSh() {
      this.dialogVisible = true;
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await shanghuInfoImport(formData);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.onSearch();
      } else this.$message.error(res.data.msg);
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      sessionStorage.setItem('shtzSearch', JSON.stringify({
        ...this.form,
        ...this.page
      }));
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.pbmc = "";
      this.form.pian = "";
      this.form.sq = "";
      this.form.zu = "";
      this.form.zrr = "";
      this.page.page = 1;
      this.page.size = 10;
      this.form.hasAccountFlag = "";
      sessionStorage.removeItem('shtzSearch');
      this.getPointTypeListPageFun();
    },
    // 编辑
    async toEdit (row) {
      this.formInline = JSON.parse(JSON.stringify(row));
      if (this.formInline.extendTimeRange && this.formInline.extendTimeRange.indexOf('-') != -1) {
        this.time1 = this.formInline.extendTimeRange.split('-')[0];
        this.time2 = this.formInline.extendTimeRange.split('-')[1];
      } else {
        this.time1 = '';
        this.time2 = '';
      }
      this.ckImgLeftJson = row.ckImgLeftJson ? JSON.parse(row.ckImgLeftJson) : [];
      this.ckImgCentreJson = row.ckImgCentreJson ? JSON.parse(row.ckImgCentreJson) : [];
      this.ckImgRightJson = row.ckImgRightJson ? JSON.parse(row.ckImgRightJson) : [];
      this.dialogVisible2 = true;
    },
    // 详情
    async toDetail(row) {
      let res = await shanghuInfoDetail({
        id: row.id
      });
      if (res.data.code == 200) {
        this.showDetail = true;
        this.formInline = JSON.parse(JSON.stringify(res.data.data));
        this.$emit('showDetail', {item: this.formInline})
      }
    },
    // 删除用户
    async deleteType(item) {
      const res = await shanghuInfoDel({
        id: item.id
      });
      if (res.data.code == 200) {
        this.getPointTypeListPageFun();
        this.$message.success('已删除');
      } else this.$message.error(res.data.msg);
    },
    // 分页查询
    async getPointTypeListPageFun() {
      this.loading = true;
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size,
        fillAccountCountFlag: true
      };
      const res = await shanghuInfoPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
      this.loading = false;
    },
    // 保存
    async addOrUpdateFun() {
      // if (!this.time1 || !this.time2) return this.$message.error('请选择打卡时段');
      if (this.time1 && this.time2) this.formInline.extendTimeRange = `${this.time1}-${this.time2}`;
      else this.formInline.extendTimeRange = '';
      if (this.ckImgLeftJson.length) this.formInline.ckImgLeftJson = JSON.stringify(this.ckImgLeftJson);
      if (this.ckImgCentreJson.length) this.formInline.ckImgCentreJson = JSON.stringify(this.ckImgCentreJson);
      if (this.ckImgRightJson.length) this.formInline.ckImgRightJson = JSON.stringify(this.ckImgRightJson);
      this.$refs["form"].validate(async valid => {
        if (valid) {
          let res = await shanghuInfoEdit(this.formInline);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.dialogVisible2 = false;
            this.onReset();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg
            });
          }
        }
      });
    },
    // 商户导出
    async exportShanghu () {
      this.exportLoading = true;
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await shanghuExp(params);
      if (res.status == 200) {
        this.exportLoading = false;
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "商户列表" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
      this.exportLoading = false;
    },
    // 模板下载
    async downloadTemplate() {
      const res = await downloadFile({
        filePath: "/template/商户台账模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "通用商户导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex {
  display: flex;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.question-detail {
  height: calc(100% - 56px);
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;

  .top {
    width: 100%;
    // height: 178px;
    padding: 24px 36px;
    background: url("~@/assets/image/question-bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .map-content {
    width: 375px;
    height: 178px;
    margin: 0 24px;
  }
}

.right-top1 {
  // width: 100%;
  margin-bottom: 8px;
  padding: 10px 24px;
  position: relative;

  .street {
    font-family: MiSans, MiSans;
    font-weight: 700;
    font-size: 24px;
    color: #494c4f;
    position: relative;
    .disposition {
      position: absolute;
      top: -10px;
      right: -80px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }

  .content {
    margin-top: 8px;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 18px;
    color: #494c4f;
  }
  .info-box {
    margin-top: 12px;
    display: flex;
    align-items: center;

    .info-box-item {
      display: flex;
      align-items: center;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 16px;
      color: #494c4f;
      margin-right: 54px;

      img,
      span {
        margin-right: 8px;
      }

      img {
        height: 15px;
      }
    }

    .info-box-item:last-child {
      margin-right: 0;
    }
  }
}

.right-bottom {
  height: calc(100% - 214px);
  width: 100%;
  // max-height: 719px;
  // min-height: 561px;

  .tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 100px;
    padding-right: 24px;
    margin-bottom: 8px;

    .tabs-box {
      display: flex;
      align-items: center;

      .tabs-item {
        padding-top: 10px;
        padding-bottom: 8px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 20px;
        color: #92979c;
        margin-right: 48px;
        cursor: pointer;
        position: relative;
      }

      .tabs-item.active {
        font-family: MiSans, MiSans;
        font-weight: 700;
        font-size: 20px;
        color: #494c4f;
      }

      .tabs-item.active::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 4px;
        width: 100%;
        background: #0090ff;
        border-radius: 2px;
      }
    }

    .tupian-box {
      display: flex;
      align-items: center;

      width: 68px;

      .tupian-item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 8px;
        height: 38px;
      }

      .tupian-item:first-child {
        border-radius: 4px 0px 0px 4px;
        border: 1px solid #e0e0e0;

        img {
          height: 16px;
        }
      }

      .tupian-item:last-child {
        border-radius: 0px 4px 4px 0px;
        border: 1px solid #e0e0e0;

        img {
          height: 20px;
        }
      }
    }
  }

  .map-content {
    width: 100%;
    height: calc(100% - 56px);
    // min-height: 505px;
  }
}

.form-content {
  padding: 20px 100px;
}
.taskDetail {
  /deep/ .el-form-item__label {
    text-align: left;
  }
}

.keyPic {
  margin-top: 8px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /deep/ .el-image {
    margin: 0 !important;
  }
  .imgPic {
    width: 234px;
    height: 234px;
    margin-right: 10px !important;
    border-radius: 4px;
  }
}

.fenbo {
  width: 410px;
  border-right: 1px solid #e0e0e0;
  margin-right: 20px;

  .list {
    width: 390px;

    height: 72px;
    background: #f7faff;
    border-radius: 4px;
    padding: 12px 24px;
    position: relative;
    margin-bottom: 12px;

    .handleDeptName {
      font-family: MiSans, MiSans;
      font-weight: 500;
      font-size: 16px;
      color: #494c4f;
      line-height: 22px;
    }
    .assignType {
      margin-right: 8px;
      padding: 0 4px;
      height: 22px;
      background: rgba(138, 144, 154, 0.09);
      border-radius: 4px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 22px;
    }
    .zhuban {
      background: rgba(4, 149, 255, 0.1);
      color: #0495ff;
    }
    .assignTime {
      margin-top: 8px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #92979c;
      line-height: 19px;
    }
    .disposition {
      position: absolute;
      top: 10px;
      right: 20px;
      img {
        width: 65px;
        height: 54px;
      }
    }
  }
  .activeList {
    border: 1px solid #0495ff;
  }
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.yituihui {
  color: #c4c6cc;
}

/deep/.el-dialog__body {
  padding: 24px;
  overflow: hidden;
}
.container-dialog {
  overflow: hidden;
  display: flex;
  .left {
    width: 100%;
    height: 660px;
    overflow: auto;
  }
}
.box {
  display: flex;
}
.box-1 {
  flex: 1;
}
.box-column {
  flex-direction: column;
}
.box-column-center {
  align-items: center;
}
.box-center {
  justify-content: center;
}
.box-center {
  justify-content: center;
  align-items: center;
}
.box-between {
  justify-content: space-between;
}

.mr-20 {
  margin-right: 20px;
}

/* 蓝色边框按钮样式 */
.btn-outline-blue {
  background-color: #fff !important;
  border-color: #409EFF !important;
  color: #409EFF !important;
}

.btn-outline-blue:hover,
.btn-outline-blue:hover i {
  background-color: #409EFF !important;
  border-color: #409EFF !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/userManagement/shtzList.vue